export default function NYEscreenshot(){
    return (
        <>
            <img src='screenshot-nye.jpg' style={{maxWidth:'100%'}} />
            

        </>
    )
}